import React from 'react';
import CommentIcon from '@atlaskit/icon/core/comment';
import Spinner from '@atlaskit/spinner';

interface ChatWidgetButtonProps {
  onClick: () => void;
  loading?: boolean;
}

const ChatWidgetButton: React.FC<ChatWidgetButtonProps> = ({ onClick, loading = false }) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="Open chat widget"
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1000,
        cursor: loading ? 'default' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '56px',
        height: '56px',
        borderRadius: '50%',
        backgroundColor: '#0052CC',
        boxShadow: '0 1px 1px rgba(9,30,66,0.25), 0 0 1px rgba(9,30,66,0.31)',
        color: 'white',
      }}
      onClick={loading ? undefined : onClick}
      onKeyDown={loading ? undefined : handleKeyDown}
    >
      {loading ? (
        <Spinner size="medium" appearance="invert" />
      ) : (
        <CommentIcon label="" color="currentColor" />
      )}
    </div>
  );
};

export default ChatWidgetButton;
